import React from "react";
import Layout3 from "components/layout/Layout3";
import Main from "./Main";

const TVISettings = (props) => {
  return (
    <Layout3>
      <Main {...props} />
    </Layout3>
  );
};

export default TVISettings;
